import React,{useEffect} from "react";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import {
    Alert,
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogContentText, DialogTitle, Grid, IconButton,
    Table,
    TableBody, TableCell, tableCellClasses,
    TableHead,
    TableRow
} from "@mui/material";
import Button from "@mui/material/Button";
import {styled} from "@mui/material/styles";
import ErrorMsg from "../msg/ErrorMsg";
import SuccsMsg from "../msg/SuccsMsg";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
const ShowOrder = ({fnumber,setChange,showorder})=>{
    const [orderList , setOrderList] = React.useState("");
    const [loading , setLoading] = React.useState(true);
    const [dialogShowOrder , setDialogShowOrder] = React.useState(true);
    const [desc , setDesc] = React.useState("");
    const [msgSuccs , setMsgSuccs] = React.useState("");
    const [errorMsg , setErrorMsg] = React.useState("");
    useEffect(()=>{
        const data = {
            factor_number : fnumber,
        }
        axios.post("https://app.zhivay.com/api/get_orderitems.php",data)
            .then(response =>{
                setOrderList(response.data);
                setDesc(response.data[0].desc)
                setLoading(false);
            })
            .catch(error =>{
                console.log(error);
                setLoading(false);
            });
    },"")
    const handleDialogClose = ()=>{
        setDialogShowOrder(false);
        showorder(false);
    }
    const handle_complate = ()=>{
        const data={
            factor_number:fnumber,
        }
        axios.post("https://app.zhivay.com/api/update_order.php",data)
            .then(response =>{
                if(response.data==="ok"){
                    setDialogShowOrder(false);
                    setChange(true);
                    setMsgSuccs("با موفقیت انجام شد");
                }
                else
                    setErrorMsg("خطا در انجام عملیات . دوباره تلاش کنید");
            })
            .catch(error =>{
                console.log(error);
                setErrorMsg("خطا در انجام عملیات . دوباره تلاش کنید");
            });
    }
    return(
        <div>
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : '' }
            {msgSuccs !== '' ? <SuccsMsg message={msgSuccs} openn={true} setsuccsmsg={msgSuccs}/> : '' }
            <Dialog
                open={dialogShowOrder}
                onClose={handleDialogClose}
                scroll="paper"
                sx={{minWidth: 250,maxHeight:'96%',}}>
                {/*<DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>*/}
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center">
                {!loading ?
                <div>
                    <DialogContent dividers={'paper'}
                    sx={{padding:1}}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}>
                        <Table
                            sx={{margin:0}}
                            className='tbl-pishfactor'>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">تعداد</StyledTableCell>
                                    <StyledTableCell align="right">نام کالا</StyledTableCell>
                                </TableRow>
                            </TableHead>
                                <TableBody>
                                    {orderList.map(order => (
                                        <StyledTableRow
                                            hover
                                            key={order.order_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <StyledTableCell component="th" scope="row" align="center">
                                                {order.good_total}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" scope="row" align="right">
                                                {order.good_name}
                                            </StyledTableCell>
                                        </StyledTableRow >
                                    ))}
                                </TableBody>
                        </Table>
                        {desc !== "" ?
                            <Box
                                dir="rtl"
                                sx={{
                                    margin:1,
                                    textAlign:"right",
                                    backgroundColor:"#f19d22",
                                    fontSize:"14px",
                                    padding:1,
                                    color:"#000000",
                                    borderRadius:1,
                            }}>
                                <p style={{marginTop:0,marginBottom:1}}>توضیحات : </p>
                                {desc}
                            </Box>
                            : '' }
                    </DialogContentText>

                </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={handleDialogClose}>بستن</Button>
                        <Button
                            onClick={handle_complate}>تکمیل سفارش
                        </Button>

                    </DialogActions>
                </div>
                    : <CircularProgress sx={{margin:2}} /> }
                </Grid>

            </Dialog>
        </div>
    )
}
export default ShowOrder;